import React from "react";
import { Link } from "react-router-dom";
import { BsGithub } from "react-icons/bs";

const Footer = () => {
  return (
    <div>
      <section className="s-email fixed-bar">
        <div className="email">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/logo.png"}
            class="img-fluid logoheader"
            alt="..."
            width="5%"
            height="5%"
          />
          <div className="ml-5 mb-5 mt-5">
            <a
              class="nav-link text-white"
              href="#Home"
              style={{ fontSize: "22px" }}
            >
              Home <span class="sr-only">(current)</span>
            </a>
            <a
              class="nav-link text-white"
              href="#Features"
              style={{ fontSize: "22px" }}
            >
              Features <span class="sr-only">(current)</span>
            </a>
            <a
              class="nav-link text-white"
              href="#InfinityPad"
              style={{ fontSize: "22px" }}
            >
              InfinityPad <span class="sr-only">(current)</span>
            </a>
          </div>

          <div className="ml-5">
            <a
              class="nav-link text-white"
              href="#Roadmap"
              style={{ fontSize: "22px" }}
            >
              Roadmap <span class="sr-only">(current)</span>
            </a>
            <a
              class="nav-link text-white"
              href="#FAQ"
              style={{ fontSize: "22px" }}
            >
              Whitepaper <span class="sr-only">(current)</span>
            </a>
            <a
              class="nav-link text-white"
              href="#Partners"
              style={{ fontSize: "22px" }}
            >
              Partners <span class="sr-only">(current)</span>
            </a>
          </div>

          <div className="social-icons">
            <a
              href="https://github.com/InfinityPad "
              target="_blank"
              className="medium_link"
              rel="Medium"
            >
              <img src="assets/images/githublogo.png" alt="icon-date" />
            </a>
            <a
              href="https://InfinityPad .medium.com/"
              target="_blank"
              className="medium_link"
              rel="Medium"
            >
              <img src="assets/images/mediumlogo.png" alt="icon-date" />
            </a>
            <a
              href="https://t.me/InfinityPad group"
              target="_blank"
              className="medium_link"
              rel="Medium"
            >
              <img src="assets/images/Telegramlogo.png" alt="icon-date" />
            </a>
            <a
              href="https://twitter.com/InfinityPad Official"
              target="_blank"
              className="medium_link"
              rel="Medium"
            >
              <img src="assets/images/twitterlogo.png" alt="icon-date" />
            </a>
          </div>
        </div>

        <div className="mr-1"></div>
        {/* <div className="email">
        <Link to="launchpad">
          <a className="btn" target="_blank" href="#">
            Enter App
          </a>
        </Link>
        <a target="_blank" href="#">
          <img
            src={process.env.PUBLIC_URL + "assets/images/infinityselo.png"}
            alt
            className="exs"
          />
        </a>
        <a target="_blank" href="#">
          <img
            src={process.env.PUBLIC_URL + "assets/images/uniswap.png"}
            alt
            className="exs"
          />
        </a>
        <a target="_blank" href="#">
          <img
            src={process.env.PUBLIC_URL + "assets/images/mexec.png"}
            alt
            className="exs"
          />
        </a>
      </div> */}
      </section>
    </div>
  );
};

export default Footer;
